import type { User } from '../types'

/**
 * Last successfully-fetched profile, persisted so an OFFLINE app boot can
 * hydrate `useAuth` without a network round-trip. Only display data the
 * user already sees in the app; tokens live in tokenStorage, not here.
 * Written on every successful profile fetch/update, cleared on sign-out
 * and on genuine auth expiry.
 */
const KEY = 'qlearn:profile-snapshot:v1'
const VERSION = 1

type Stored = { v: number; user: User; savedAt: string }

export function readProfileSnapshot(): User | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<Stored>
    if (parsed.v !== VERSION || !parsed.user || typeof parsed.user !== 'object') return null
    return parsed.user
  } catch {
    return null
  }
}

export function writeProfileSnapshot(user: User): void {
  try {
    const blob: Stored = { v: VERSION, user, savedAt: new Date().toISOString() }
    localStorage.setItem(KEY, JSON.stringify(blob))
  } catch {
    // Private mode / quota: snapshot is best-effort.
  }
}

export function clearProfileSnapshot(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // ignore
  }
}
